import {handleSendFunctionResponseToShotListAgent} from "../services/handleSendFunctionResponseToShotListAgent";

export const getEntireShotListState = async (updatedChatSession, shotListState, setChatSession, userInfo) =>{
    const entireShotListState = [...shotListState];
   const responseMessage = `FunctionResponse: The current state of the entire shot list is as follows: ${JSON.stringify(entireShotListState, null, 2)}.`
    const response = {
        role: "user",
        parts: [
          {
            text: responseMessage
          }
        ]
    }
    await handleSendFunctionResponseToShotListAgent(response, updatedChatSession, setChatSession, userInfo);
}